
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import SectionModule from '~/store/section';
import DocumentUploadModule from '~/store/documentUpload';

@Component<Header>({
})
export default class Header extends Vue {
    @Resolve
    public sectionStore!: SectionModule;

    @Resolve
    uploadModule!: DocumentUploadModule;

    redirectToLandingPage() {
        this.uploadModule.clearStore();
        this.sectionStore.resetSelections();
        this.$router.push('/');
    }
    public get headerLogoGSK() {
        return this.$settings.url(this.$settings.headerLogoGSK);
    }
    public get headerLogoLine() {
        return this.$settings.url(this.$settings.headerLogoLine);
    }
    public get headerLogoOneSource() {
        return this.$settings.url(this.$settings.headerLogoOneSource);
    }

}
